import React from "react";
import RegFont from "./common/RegFont";

function SimpleText(props) {
  return (
    <>
      {props.textLines.map((text) => (
        <RegFont key={text}>{text}</RegFont>
      ))}
    </>
  );
}

export default SimpleText;
